/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_New_Visitor_CommentInputs */

const en_admin_external_booking_new_visitor_comment = /** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitor Comment`)
};

const de_admin_external_booking_new_visitor_comment = /** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besucherkommentar`)
};

const es_admin_external_booking_new_visitor_comment = /** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentario del visitante`)
};

const fr_admin_external_booking_new_visitor_comment = /** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaire du visiteur`)
};

/** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */
const it_admin_external_booking_new_visitor_comment = en_admin_external_booking_new_visitor_comment;

/** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */
const pt_br2_admin_external_booking_new_visitor_comment = en_admin_external_booking_new_visitor_comment;

/** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */
const pl_admin_external_booking_new_visitor_comment = en_admin_external_booking_new_visitor_comment;

/** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */
const hu_admin_external_booking_new_visitor_comment = en_admin_external_booking_new_visitor_comment;

/** @type {(inputs: Admin_External_Booking_New_Visitor_CommentInputs) => LocalizedString} */
const ro_admin_external_booking_new_visitor_comment = en_admin_external_booking_new_visitor_comment;

/**
* | output |
* | --- |
* | "Visitor Comment" |
*
* @param {Admin_External_Booking_New_Visitor_CommentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_new_visitor_comment = /** @type {((inputs?: Admin_External_Booking_New_Visitor_CommentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_New_Visitor_CommentInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_new_visitor_comment(inputs)
	if (locale === "de") return de_admin_external_booking_new_visitor_comment(inputs)
	if (locale === "es") return es_admin_external_booking_new_visitor_comment(inputs)
	if (locale === "fr") return fr_admin_external_booking_new_visitor_comment(inputs)
	if (locale === "it") return it_admin_external_booking_new_visitor_comment(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_new_visitor_comment(inputs)
	if (locale === "pl") return pl_admin_external_booking_new_visitor_comment(inputs)
	if (locale === "hu") return hu_admin_external_booking_new_visitor_comment(inputs)
	return ro_admin_external_booking_new_visitor_comment(inputs)
});
export { admin_external_booking_new_visitor_comment as "admin.external_booking_new.visitor_comment" }